module.exports = __webpack_public_path__ + "img/av053.e05206c7.png";